import Animator from "./Animator";
import Utils from "./Utils";
import EventEmitter from "./EventEmitter";

export default class DrawingLogic extends EventEmitter {
  constructor(refCanvas) {
    super();
    this.width = refCanvas.width;
    this.height = refCanvas.height;
    this.ctx = refCanvas.getContext("2d");
    // Angle for the pen width effect
    this.angle = 212;
    // Used to kill the lines construction if the user click
    this.stopStepProcess = false;
    // GREY for the outline
    this.LINE_COLOR = "rgba(136,136,136,1)";
    // Debug COLOR
    this.BLUE = "rgba(66,133,244,0.4)";
    //
    this.IS_RESETTING = false;
    //
    this.KILLING = false;
    // DEFAULT SCALE
    this.SCALE = 1;
    this.animator = new Animator();
    /** NOT USED ANYMORE */
    this.animator.color = this.BLUE; //this.LINE_COLOR;
    this.animator.addEventListener(
      "continueDrawing",
      this.continueDrawing.bind(this)
    );
    // memoryCanvas
    this.memoryCanvas = document.createElement("canvas");
    this.memoryCanvas.width = this.width;
    this.memoryCanvas.height = this.height;
    this.memory = this.memoryCanvas.getContext("2d");
    this.memory.fillStyle = "white";
    this.memory.fillRect(0, 0, this.width, this.height);
    //
    this.DATA = null;
  }
  set simplifyPoints(data) {
    this._simplifyPoints = data;
    this.comparePoints(this.SCALE);
  }
  get simplifyPoints() {
    return this._simplifyPoints;
  }
  set lines(data) {
    this.IS_RESETTING = false;
    this._lines = data;
    this.getTheLines(this.SCALE);
  }
  get lines() {
    return this._lines;
  }
  get color() {
    return this.LINE_COLOR;
  }
  get length() {
    return this._fullDrawingByLines.length;
  }
  onResize(dimension, updateLines) {
    this.memoryCanvas.width = this.width = dimension.width;
    this.memoryCanvas.height = this.height = dimension.height;
    this.memory = this.memoryCanvas.getContext("2d");
    this.memory.fillStyle = "white";
    this.memory.fillRect(0, 0, this.width, this.height);
    //
    this.reset();
    // this.DATA = null;
    //
    if (updateLines) this.getTheLines(this.SCALE);
    // console.log("FROM DRAWING LOGIC", this.width, this.height);
  }
  down() {
    if (!this.animator.drawing_is_done && this.savedSegment) {
      console.log("::: SAVE ACTIVE SEGMENT :::");
      this.drawSavedSegment(/*this.LINE_COLOR*/ this.BLUE, this.SCALE);
    }
    this.stopStepProcess = true;
  }
  update() {
    if (!this.KILLING) this.animator.update();
  }
  draw() {
    if (this.animator.seg2Lerp) {
      this.animator.seg2Lerp.forEach((seg) => {
        this.drawLine(seg[0], /*this.LINE_COLOR*/ this.BLUE, this.ctx);
      });
    }
  }
  debug() {
    // clear previous lines !!
    this.drawWithThickness(this.SCALE);
  }
  print(ctx) {
    this.DATA = ctx.getImageData(0, 0, this.width, this.height);
  }
  reset(reload = false) {
    this.IS_RESETTING = true;
    this.KILLING = false;
    this.DATA = null;
    this.stopStepProcess = true;
    this.animator.animation = null;
    this.animator.seg2Lerp = null;
    this.animator.AUTOMATED_EXTRA_STEPS = 10;
    this.animator.DEFAULT_SPEED = 75;
    this.memory.fillStyle = "white";
    this.memory.fillRect(0, 0, this.width, this.height);
    if (reload) {
      this.savedSegment = null;
      this._lines = null;
      this._fullDrawingByLines = null;
    }
  }
  continueDrawing(data) {
    console.log("continue drawing", data);
    this.drawSavedSegment(/*this.LINE_COLOR*/ this.BLUE, this.SCALE);
    // setTimeout(() => {
    this.drawWithThicknessByStep(
      this.memory,
      data.index,
      data.steps,
      this.SCALE,
      data.speed
    );
    // }, 2000);
  }
  getTheLines(scale = 1) {
    try {
      this._fullDrawingByLines = [];
      const point = { x: 0, y: 0 };
      let next_is_moveTo = false;
      this._lines.forEach((item, i) => {
        if (i == 0) {
          this._fullDrawingByLines.push([
            { x: item[0] * scale, y: item[1] * scale },
          ]);
        } else {
          point.x += item[0] * scale;
          point.y += item[1] * scale;
          if (next_is_moveTo) {
            this._fullDrawingByLines.push([{ x: point.x, y: point.y }]);
          } else {
            this._fullDrawingByLines[this._fullDrawingByLines.length - 1].push({
              x: point.x,
              y: point.y,
            });
          }
          if (item[2] > 0) {
            next_is_moveTo = true;
          } else {
            next_is_moveTo = false;
          }
        }
      });
    } catch (error) {
      console.log("model probably not ready yet");
    }
  }
  drawSavedSegment(color = "black", scale = 1) {
    if (this.DATA) this.memory.putImageData(this.DATA, 0, 0);
    try {
      let { min_x, max_x, min_y, max_y } = this.get_bounds(
        this.lines,
        1 / scale
      );
      this.memory.save();
      this.memory.translate(
        min_x < 0 ? -min_x : min_x,
        min_y < 0 ? -min_y : min_y
      );
      this.savedSegment.forEach((line, i) => {
        if (line) this.drawLine(line, color, this.memory);
      });
      this.memory.restore();
      this.DATA = this.memory.getImageData(0, 0, this.width, this.height);
      if (this.IS_RESETTING) {
        this.DATA = null;
      }
    } catch (error) {
      console.log(error);
    }
  }
  drawWithThickness(scale = 1) {
    // get Bounds
    try {
      let { min_x, max_x, min_y, max_y } = this.get_bounds(
        this.lines,
        1 / scale
      );
      const width = max_x - min_x;
      const height = max_y - min_y;
      this.ctx.save();
      this.ctx.translate(
        min_x < 0 ? -min_x : min_x,
        min_y < 0 ? -min_y : min_y
      );
      this._fullDrawingByLines.forEach((line, i) => {
        this.drawLine(line, this.BLUE, this.ctx);
      });
      this.ctx.restore();
    } catch (error) {
      console.log(error);
    }
  }
  drawLine(points, color, ctx) {
    const radius = 2 * this.SCALE;
    const angle = this.angle * (Math.PI / 180);
    const shape = { up_lines: [], down_lines: [] };
    points.forEach((point) => {
      const up = {
        x: point.x + Math.cos(angle) * radius,
        y: point.y + Math.sin(angle) * radius,
      };
      const down = {
        x: point.x - Math.cos(angle) * radius,
        y: point.y - Math.sin(angle) * radius,
      };
      shape.up_lines.push(up);
      shape.down_lines.unshift(down);
    });
    const allpoints = shape.up_lines.concat(shape.down_lines);
    ctx.fillStyle = color; // this.sketch_color;
    ctx.beginPath();
    allpoints.forEach((point, i) => {
      if (i == 0) {
        ctx.moveTo(point.x, point.y);
      } else {
        ctx.lineTo(point.x, point.y);
      }
    });
    ctx.fill();
    ctx.closePath();
  }
  erase(points, color, ctx) {
    ctx.fillStyle = color;
    points.forEach((point) => {
      ctx.beginPath();
      ctx.arc(point.x, point.y, 8, 0, Math.PI * 2, false);
      ctx.fill();
      ctx.closePath();
    });
  }
  drawWithThicknessByStep(ctx, index = 0, max = 1, scale = 1, speed = 75) {
    if (this.DATA) {
      ctx.putImageData(this.DATA, 0, 0);
    }
    try {
      // get Bounds
      let { min_x, max_x, min_y, max_y } = this.get_bounds(
        this.lines,
        1 / scale
      );
      ctx.save();
      ctx.translate(min_x < 0 ? -min_x : min_x, min_y < 0 ? -min_y : min_y);
      // GET THE END OF THE LINE
      let end = index + max;
      if (end >= this._fullDrawingByLines.length) {
        end = end - this._fullDrawingByLines.length;
      }
      console.log("END IS : ", end, this._fullDrawingByLines.length);
      if (!this.KILLING) this.step(ctx, index, end, speed);
    } catch (error) {
      console.log(error);
    }
  }
  step(ctx, index, end, speed) {
    if (this.stopStepProcess) {
      ctx.restore();
      this.animator.drawing_is_done = true;
      this.animator.pause = false;
      if (this.IS_RESETTING) {
        this.DATA = null;
        ctx.fillStyle = "white";
        ctx.fillRect(0, 0, this.width, this.height);
      }
      return;
    }
    if (
      index < end ||
      (index > end && index < this._fullDrawingByLines.length)
    ) {
      let line = this._fullDrawingByLines[index];
      this.drawLine(line, /*this.LINE_COLOR*/ this.BLUE, ctx);
      setTimeout(() => {
        index++;
        if (end < index && index >= this._fullDrawingByLines.length) {
          index = 0;
        }
        this.step(ctx, index, end, speed);
      }, speed);
    } else {
      ctx.restore();
      this.animator.drawing_is_done = true;
      this.animator.pause = false;
      this.raiseEvent("completed", []);
    }
    this.DATA = ctx.getImageData(0, 0, this.width, this.height);
  }
  comparePoints(scale = 1) {
    try {
      let { min_x, max_x, min_y, max_y } = this.get_bounds(
        this.lines,
        1 / scale
      );
      const offsetX = min_x < 0 ? -min_x : min_x;
      const offsetY = min_y < 0 ? -min_y : min_y;
      this.savedSegment = [];
      this.savedAnimatedSegment = [];
      const limit = 30;
      let includedLines = [];
      this._simplifyPoints.forEach((point, i) => {
        let maxDist = 100000;
        let resultingLine = null;
        let savedindex = null;
        this._fullDrawingByLines.forEach((line, index) => {
          line.forEach((p) => {
            const _dist = Utils.dist(
              point.x,
              point.y,
              p.x + offsetX,
              p.y + offsetY
            );
            if (_dist < maxDist /*&& _dist < limit*/) {
              maxDist = _dist;
              resultingLine = line;
              savedindex = index;
            }
          });
        });
        if (!includedLines.includes(savedindex)) {
          this.savedSegment.push(resultingLine);
          this.savedAnimatedSegment.push({
            line: resultingLine,
            originSegment: [
              point,
              this._simplifyPoints[
                i < this._simplifyPoints.length - 1 ? i + 1 : i
              ],
            ],
            offset: { x: offsetX, y: offsetY },
            index: savedindex,
            lineIndex: i,
          });

          includedLines.push(savedindex);
        }
      });
      this.stopStepProcess = false;
      this.animator.setNewSegments(this.savedAnimatedSegment);
    } catch (error) {
      console.log(error);
    }
  }
  get_bounds(json, factor = 1) {
    if (json) {
      let min_x = 0;
      let max_x = 0;
      let min_y = 0;
      let max_y = 0;

      let abs_x = 0;
      let abs_y = 0;
      json.forEach((data) => {
        const x = parseFloat(data[0]) / factor;
        const y = parseFloat(data[1]) / factor;

        abs_x += x;
        abs_y += y;

        min_x = Math.min(min_x, abs_x);
        // Clamp dimensions to a max of widht / height (sometimes smaller than 512 px on mobile)
        // const unclamped_min_y = Math.min(min_y, abs_y);
        // const unclamped_max_x = Math.max(max_x, abs_x);
        // min_y = Math.max(-this.width, unclamped_min_y);
        // max_x = Math.min(this.width, unclamped_max_x);
        // max_y = Math.max(max_y, abs_y);
        /*
        BACK TO ORIGINAL , BECAUSE OF CROPPING
        */
        // min_x = Math.min(min_x, abs_x);
        min_y = Math.min(min_y, abs_y);
        max_x = Math.max(max_x, abs_x);
        max_y = Math.max(max_y, abs_y);
      });
      // console.log('get bounds, returning', min_x, max_x, min_y, max_y);
      return { min_x, max_x, min_y, max_y };
    } else {
      console.log("error with json");
      throw "Json is not loaded yet";
    }
  }
}
